export const UserOnboardingData = {
  onboarding_details: {
    workspace: {
      supademoUrl: "https://app.supademo.com/demo/cmq4rgqaa08rf080jdr8y5ryi?utm_source=link",
      touchPointDescription: "Workspace",
      modalHeading: "Learn how to build your workspace and do enrichment on the shortlisted companies.",
      title: "Workspace",
      brief: "Discover how to build your workspace and do enrichment on the shortlisted companies.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1781186008/intel/misc/Workspace_1_rmfgtc.webp",
      isViewed: false,
      isNew: true,
    },
    product_search: {
      supademoUrl: "https://app.supademo.com/demo/cmo2kjzas0007z90j3eurc1w5?utm_source=link",
      touchPointDescription: "Find Buyers & Suppliers",
      modalHeading: "Learn how to find right buyers-suppliers , market trends for your products.",
      title: "Find Buyers & Suppliers",
      brief: "Discover how to find right buyers-suppliers , market trends for your products.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1780464659/intel/misc/Product_search_1_unb4fn.webp",
      isViewed: false,
      isNew: true,
    },
    how_to_search: {
      supademoUrl: "https://app.supademo.com/embed/cmel9zcxp01j6wu0i74975om9?embed_v=2&utm_source=embed",
      touchPointDescription: "How to search",
      modalHeading: "Learn how to run powerful searches to quickly uncover the right opportunities.",
      title: "How to search",
      brief: "Learn how to run powerful searches to quickly uncover the right opportunities.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1756453500/intel/misc/search_tkxqny.svg",
      isViewed: false,
    },
    navigating_search_results: {
      supademoUrl: "https://app.supademo.com/embed/cmev5igdo03vo1k0in111pjt0?embed_v=2&utm_source=embed",
      touchPointDescription: "Navigating Search Results",
      modalHeading: "See how to filter, refine, and interpret results for faster decision-making.",
      title: "Navigating Search Results",
      brief: "See how to filter, refine, and interpret results for faster decision-making.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1756453497/intel/misc/UE_lwqhep.svg",
      isViewed: false,
    },
    company_insights: {
      supademoUrl: "https://app.supademo.com/embed/cmemj0uil00of370i31tzdeam?embed_v=2&utm_source=embed",
      touchPointDescription: "Company Insights",
      modalHeading: "Discover how to explore detailed company profiles for buyer and supplier intelligence.",
      title: "Company Insights",
      brief: "Discover how to explore detailed company profiles for buyer and supplier intelligence.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1756453500/intel/misc/Companyprofile_j3chvz.svg",
      isViewed: false,
    },
    fetch_prospects_contacts: {
      supademoUrl: "https://app.supademo.com/embed/cmemnsalv00evxp0icvd9p8s6?embed_v=2&utm_source=embed",
      touchPointDescription: "Accessing Contacts",
      modalHeading: "Learn how to find, request, and manage verified decision-maker details with ease.",
      title: "Accessing Contacts",
      brief: "Learn how to find, request, and manage verified decision-maker details with ease.",
      image: "https://res.cloudinary.com/drzta9shk/image/upload/v1756453497/intel/misc/Contact_plbely.svg",
      isViewed: false,
    },
  },
  strip_touchpoints_details: {
    finding_better_prospects_shipments_page_importers_tab: {
      supademoUrl: "https://app.supademo.com/embed/cmf11o3eo02kfwh0irfzx75r8?embed_v=2&utm_source=embed",
      touchPointDescription: "Learn how to find better prospects?",
      modalHeading: "Learn how to find better prospects",
      title: "Find Prospects",
      brief: "Enhance product-to-company search efficiency using product names or HS code filtering.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingImportersTabClick",
    },
    finding_better_prospects_shipments_page_exporters_tab: {
      supademoUrl: "https://app.supademo.com/embed/cmf11o3eo02kfwh0irfzx75r8?embed_v=2&utm_source=embed",
      touchPointDescription: "Learn how to find better prospects?",
      modalHeading: "Learn how to find better prospects",
      title: "Find Prospects",
      brief: "Enhance product-to-company search efficiency using product names or HS code filtering.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingExportersTabClick",
    },
    how_to_analyse_trends_viewTrends_page: {
      supademoUrl: "https://app.supademo.com/embed/cmf11l9qx03vczw0ig9pi7dsd?embed_v=2&utm_source=embed",
      touchPointDescription: "Learn how to analyse shipment attributes",
      modalHeading: "Learn how to analyse shipment attributes",
      title: "Analyse Trends",
      brief: "Analyse shipment attributes as trends, ranking and grouping them using different measurements.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingAnalyticsDashlet",
    },
    analyse_companyProfile_page_as_buyer: {
      supademoUrl: "https://app.supademo.com/embed/cmemj0uil00of370i31tzdeam?embed_v=2&utm_source=embed",
      touchPointDescription: "Learn to analyse company as buyer",
      modalHeading: "Company Insights",
      title: "Analyse Company",
      brief: "Discover how to explore detailed company profiles for supplier side intelligence.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingCompanyProfileBuyer",
    },
    analyse_companyProfile_page_as_supplier: {
      supademoUrl: "https://app.supademo.com/embed/cmemj0uil00of370i31tzdeam?embed_v=2&utm_source=embed",
      touchPointDescription: "Learn to analyse company as supplier",
      modalHeading: "Company Insights",
      title: "Analyse Company",
      brief: "Discover how to explore detailed company profiles for buyer side intelligence.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingCompanyProfileSupplier",
    },
    fetch_prospects_contacts: {
      supademoUrl: "https://app.supademo.com/embed/cmemnsalv00evxp0icvd9p8s6?embed_v=2&utm_source=embed",
      touchPointDescription: "How to Find Contacts",
      modalHeading: "Fetch contacts",
      title: "How to Find Contacts",
      brief: "Learn how to find, request, and manage verified decision-maker details with ease.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingCompanyProfileContacts",
    },
    hs_classifier: {
      supademoUrl: "https://app.supademo.com/embed/cmfpblkok000ave0iytbpn7hz?v_email=EMAIL&embed_v=2&utm_source=embed",
      touchPointDescription: "Learn how to classify HS Code",
      modalHeading: "Learn how to classify HS Code",
      title: "How to classify HS Code",
      brief: "Learn to classify your products with our AI-enabled HS Classification tool — making your search more accurate than ever.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "",
    },
    product_search: {
      supademoUrl: "https://app.supademo.com/demo/cmo2kjzas0007z90j3eurc1w5?utm_source=link",
      touchPointDescription: "Find Buyers & Suppliers",
      modalHeading: "Learn how to find right buyers-suppliers , market trends for your products.",
      title: "Find Buyers & Suppliers",
      brief: "Discover how to find right buyers-suppliers , market trends for your products.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingProductSearchTouchpoint",
    },
    workspace: {
      supademoUrl: "https://app.supademo.com/demo/cmq4rgqaa08rf080jdr8y5ryi?utm_source=link",
      touchPointDescription: "Workspace",
      modalHeading: "Learn how to build your workspace and do enrichment on the shortlisted companies.",
      title: "Workspace",
      brief: "Discover how to build your workspace and do enrichment on the shortlisted companies.",
      image: "https://placehold.co/340x190/png",
      isViewed: false,
      pendoEnum: "onboardingWorkspaceTouchpoint",
    },
  },
};
